import RTECompose from 'contentful/RTE_compose';
import useContentfulPreview from 'hooks/useContentfulPreview';

const ContentfulLibraryShow = ({ content }) => {
  const { fields } = useContentfulPreview(content);
  const { content: pageContent } = fields;

  return (
    <div>
      {pageContent && <RTECompose content={pageContent} fieldType="content" />}
    </div>
  );
};

export default ContentfulLibraryShow;
